/* tslint:disable */
/* eslint-disable */
/**
 * mindd-stim3-home-api-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { TherapyCheckIn } from '../model';
// @ts-ignore
import type { TherapyCheckInProgress } from '../model';
// @ts-ignore
import type { TherapyCheckInProgressRequest } from '../model';
/**
 * TherapyCheckInControllerApi - axios parameter creator
 * @export
 */
export const TherapyCheckInControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 환자가 작성한 체크인 원본을 최신 날짜순으로 돌려준다. 격자·회차는 프론트가 처방의 param.dates 와 조합해 그린다.
         * @summary 처방별 치료 체크인 내역 조회 (기관)
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHistory1: async (prescriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('findHistory1', 'prescriptionId', prescriptionId)
            const localVarPath = `/api/v1/prescriptions/{prescriptionId}/check-ins`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 처방 id 목록을 받아 처방당 목표 횟수·작성 횟수·마지막 체크인 시각을 반환한다. 마지막 체크인 시각은 치료한 날짜가 아니라 작성 시각 기준이며, 체크인이 없으면 null 이다. 존재하지 않는 id, 다른 기관 처방, 삭제된 처방은 응답에서 제외한다(부분 성공). 응답 순서는 보장하지 않으므로 prescriptionId 로 매핑한다.
         * @summary 처방별 치료 체크인 진행률 벌크 조회 (기관)
         * @param {TherapyCheckInProgressRequest} therapyCheckInProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProgresses: async (therapyCheckInProgressRequest: TherapyCheckInProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapyCheckInProgressRequest' is not null or undefined
            assertParamExists('findProgresses', 'therapyCheckInProgressRequest', therapyCheckInProgressRequest)
            const localVarPath = `/api/v1/check-ins/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapyCheckInProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TherapyCheckInControllerApi - functional programming interface
 * @export
 */
export const TherapyCheckInControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TherapyCheckInControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 환자가 작성한 체크인 원본을 최신 날짜순으로 돌려준다. 격자·회차는 프론트가 처방의 param.dates 와 조합해 그린다.
         * @summary 처방별 치료 체크인 내역 조회 (기관)
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findHistory1(prescriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapyCheckIn>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findHistory1(prescriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TherapyCheckInControllerApi.findHistory1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 처방 id 목록을 받아 처방당 목표 횟수·작성 횟수·마지막 체크인 시각을 반환한다. 마지막 체크인 시각은 치료한 날짜가 아니라 작성 시각 기준이며, 체크인이 없으면 null 이다. 존재하지 않는 id, 다른 기관 처방, 삭제된 처방은 응답에서 제외한다(부분 성공). 응답 순서는 보장하지 않으므로 prescriptionId 로 매핑한다.
         * @summary 처방별 치료 체크인 진행률 벌크 조회 (기관)
         * @param {TherapyCheckInProgressRequest} therapyCheckInProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findProgresses(therapyCheckInProgressRequest: TherapyCheckInProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapyCheckInProgress>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findProgresses(therapyCheckInProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TherapyCheckInControllerApi.findProgresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TherapyCheckInControllerApi - factory interface
 * @export
 */
export const TherapyCheckInControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TherapyCheckInControllerApiFp(configuration)
    return {
        /**
         * 환자가 작성한 체크인 원본을 최신 날짜순으로 돌려준다. 격자·회차는 프론트가 처방의 param.dates 와 조합해 그린다.
         * @summary 처방별 치료 체크인 내역 조회 (기관)
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHistory1(prescriptionId: string, options?: any): AxiosPromise<Array<TherapyCheckIn>> {
            return localVarFp.findHistory1(prescriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 처방 id 목록을 받아 처방당 목표 횟수·작성 횟수·마지막 체크인 시각을 반환한다. 마지막 체크인 시각은 치료한 날짜가 아니라 작성 시각 기준이며, 체크인이 없으면 null 이다. 존재하지 않는 id, 다른 기관 처방, 삭제된 처방은 응답에서 제외한다(부분 성공). 응답 순서는 보장하지 않으므로 prescriptionId 로 매핑한다.
         * @summary 처방별 치료 체크인 진행률 벌크 조회 (기관)
         * @param {TherapyCheckInProgressRequest} therapyCheckInProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProgresses(therapyCheckInProgressRequest: TherapyCheckInProgressRequest, options?: any): AxiosPromise<Array<TherapyCheckInProgress>> {
            return localVarFp.findProgresses(therapyCheckInProgressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TherapyCheckInControllerApi - object-oriented interface
 * @export
 * @class TherapyCheckInControllerApi
 * @extends {BaseAPI}
 */
export class TherapyCheckInControllerApi extends BaseAPI {
    /**
     * 환자가 작성한 체크인 원본을 최신 날짜순으로 돌려준다. 격자·회차는 프론트가 처방의 param.dates 와 조합해 그린다.
     * @summary 처방별 치료 체크인 내역 조회 (기관)
     * @param {string} prescriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapyCheckInControllerApi
     */
    public findHistory1(prescriptionId: string, options?: RawAxiosRequestConfig) {
        return TherapyCheckInControllerApiFp(this.configuration).findHistory1(prescriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 처방 id 목록을 받아 처방당 목표 횟수·작성 횟수·마지막 체크인 시각을 반환한다. 마지막 체크인 시각은 치료한 날짜가 아니라 작성 시각 기준이며, 체크인이 없으면 null 이다. 존재하지 않는 id, 다른 기관 처방, 삭제된 처방은 응답에서 제외한다(부분 성공). 응답 순서는 보장하지 않으므로 prescriptionId 로 매핑한다.
     * @summary 처방별 치료 체크인 진행률 벌크 조회 (기관)
     * @param {TherapyCheckInProgressRequest} therapyCheckInProgressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapyCheckInControllerApi
     */
    public findProgresses(therapyCheckInProgressRequest: TherapyCheckInProgressRequest, options?: RawAxiosRequestConfig) {
        return TherapyCheckInControllerApiFp(this.configuration).findProgresses(therapyCheckInProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

